import React, { useCallback } from 'react';
import classNames from 'classnames';
import { DataRoomNodeProps } from '../../types';
import { displayDataRoomNodeSize, getNodeMimeType } from 'utils';
import { Checkbox } from 'ncoded-component-library';
import MymeTypeIcon from 'router/subrouters/DataRoom/components/DataRoomDocumentsRouter/components/MymeTypeIcon';

import './DataRoomFile.styles.scss';

const DataRoomFile: React.FC<DataRoomNodeProps> = (props) => {
  const { className, node, disabledLabel, onChange } = props;

  const { _id, document, name, checked, disabled } = node || {};

  const classes = classNames(
    'data-room-file',
    { selected: checked, disabled },
    className,
  );

  const nodeSize = document?.size;

  const handleChange = useCallback(() => {
    if (disabled) return;

    onChange(_id, !checked);
  }, [_id, disabled, checked, onChange]);

  return (
    <div className={classes}>
      <Checkbox
        checked={checked}
        disabled={disabled}
        onChange={handleChange}
        label={
          <div>
            <div className="name">
              <MymeTypeIcon mimeType={getNodeMimeType(node)} />
              <p>{name}</p>

              {disabled && <p>{disabledLabel}</p>}
            </div>

            <p>{displayDataRoomNodeSize(nodeSize)}</p>
          </div>
        }
      />
    </div>
  );
};

export default DataRoomFile;
